import { httpsCallable } from "firebase/functions";
import { functions } from "../../../config/firebase-config";
import { uploadAuctionImage } from "./uploadAuctionImage";
import { uploadPhotoBatch } from './uploadPhotoBatch';
import { cleanupImages } from "../helpers";
import { notifyPermissionDenied } from "../handleCallableError";

// Extrae el mensaje legible del backend (HttpsError v2): busca en
// error.details y en el prefijo "code: mensaje" de error.message.
const callableErrorMessage = (error) => {
  if (!error) return "No se pudo crear la subasta";
  let details = error.details;
  if (details === undefined || details === "function failed") {
    const msg = typeof error.message === "string" ? error.message : "";
    const match = msg.match(/^[\w/-]+:\s*(.+)$/);
    if (match) return match[1];
    return msg && msg !== "internal"
      ? msg
      : "No se pudo crear la subasta";
  }
  if (typeof details === "string") return details;
  if (details && typeof details.message === "string") return details.message;
  return "No se pudo crear la subasta";
};

export const createNewAuction = async (newAuctionData) => {
  const {
    brand,
    model,
    version,
    year,
    dealership,
    dealershipId,
    operatingUnitId,
    kms,
    location,
    price,
    fastWin,
    tradeInPrice,
    front,
    pictures,
    auctionEndTime,
    plate,
    apprasing,
    observations,
    groupId,
    adminEmail,
    appraisalId,
    photoSetId,
  } = newAuctionData;

  let uploadedImages = [];

  try {
    // Alta desde la app de peritajes: las imágenes ya están en el set y se
    // resuelven server-side con `photoSetId`. No se sube nada desde la web.
    if (photoSetId) {
      const createAuctionFn = httpsCallable(functions, 'createNewAuctionV2');
      const result = await createAuctionFn({
        brand,
        model,
        version,
        year,
        dealership,
        dealershipId,
        operatingUnitId,
        requestedApp: 'dealership_web',
        kms,
        location,
        price,
        fastWin,
        tradeInPrice,
        frontURL: null,
        picturesURL: [],
        apprasingURL: [],
        auctionEndTime,
        plate,
        observations,
        groupId,
        adminEmail,
        appraisalId,
        photoSetId,
      });
      return result.data;
    }

    // DOM-AUC-008/009: subida autorizada vía callable (path por
    // dealership/unidad/subasta; borradores limpios por el scheduler).
    const { frontURL, picturesURL: picturesURLs, apprasingURL: apprasingURLs } = await uploadPhotoBatch(
      { front, pictures, apprasing },
      (image, imageType) => uploadAuctionImage(image, { imageType, dealershipId, operatingUnitId }),
      { onUploaded: url => uploadedImages.push(url) },
    );

    const createAuctionFn = httpsCallable(functions, "createNewAuctionV2");
    const result = await createAuctionFn({
      brand,
      model,
      version,
      year,
      dealership,
      dealershipId,
      operatingUnitId,
      requestedApp: "dealership_web",
      kms,
      location,
      price,
      fastWin,
      tradeInPrice,
      frontURL,
      picturesURL: picturesURLs,
      apprasingURL: apprasingURLs,
      auctionEndTime,
      plate,
      observations,
      groupId,
      adminEmail,
      appraisalId,
    });

    return result.data;
  } catch (error) {
    console.error("Error creating auction:", error);
    notifyPermissionDenied(error);

    if (uploadedImages.length > 0) {
      console.warn(
        "🚨 Error en creación de subasta, limpiando imágenes subidas...",
      );
      await cleanupImages(uploadedImages);
    }

    return {
      success: "no",
      message: callableErrorMessage(error),
      error: error.message,
      code: error.code || null,
    };
  }
};
